import * as React from 'react'
import styled from 'styled-components'
import * as constants from 'static/constants'
import { Tooltip } from 'components/atoms/Tooltip'

interface IAgentRank {
  id: number
  name: string | null
  name_en: string | null
  name_ja: string | null
  position: number
  rank_id: number | null
  user_id: number
}

interface IProps {
  agentRank: IAgentRank | null | undefined
  guideFee?: number
}

export const AgentRankTag: React.VFC<IProps> = React.memo(({ agentRank, guideFee }) => {
  if (!agentRank || !agentRank.name) {
    return null
  }

  let rankClass = null
  switch (agentRank.name) {
    case 'S':
      rankClass = 'S'
      break
    case 'A+':
      rankClass = 'Aplus'
      break
    case 'A':
      rankClass = 'A'
      break
    case 'B':
      rankClass = 'B'
      break
  }

  return (
    <Tooltip
      content={guideFee != null ? `業務委託料: ¥${guideFee?.toLocaleString() || 0}` : ''}
      position="bottom"
    >
      <RankTagWrapper className={rankClass ? `rank-${rankClass}` : undefined}>
        {agentRank.name}
      </RankTagWrapper>
    </Tooltip>
  )
})

const RankTagWrapper = styled.div`
  min-width: 20px;
  font-size: 12px;
  line-height: 12px;
  padding: 2px 4px;
  border-radius: 4px;
  background-color: ${constants.COLORS.infoBG2};
  font-weight: 600;
  text-align: center;
  color: ${constants.COLORS.black};
  &.rank-S {
    background-color: #ff7f7f;
  }
  &.rank-Aplus {
    background-color: #ffbf7f;
  }
  &.rank-A {
    background-color: #ffdf7f;
  }
  &.rank-B {
    background-color: #bfff7f;
  }
`
